import {Trans} from 'react-i18next';
import React from 'react';

export const getGroupedOptions = (isSkinAnalysis, isSimulation) => {
  return [
    {
      show: true,
      label: (
        <Trans i18nKey="p.s.uiconfiguration.tabs.common.settings">
          Common Settings
        </Trans>
      ),
      options: [
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.tabs.common.settings">
              Common Settings
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/common-settings',
        },
        {
          label: (
            <Trans i18nKey="p.s.app.settings.title">
              Name Preferences
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/name-preferences',
        },
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.landingpage.title">
              Landing Page
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/landing',
        },
        {
          label: (
            <Trans i18nKey="p.s.c.customization.user.consent">
              User Consent
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/user-consent',
        },
      ],
    },
    {
      show: true,
      label: (
        <Trans i18nKey="c.l.sidebar.1150.skincarepro.title">Survey Form</Trans>
      ),
      options: [
        {
          label: (
            <Trans i18nKey="c.l.sidebar.1150.skincarepro.title">
              Survey Form
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/survey-form',
        },
      ],
    },
    {
      show: isSkinAnalysis,
      label: (
        <Trans i18nKey="p.w.r.overview.skin.analysis.title">
          Skin Analysis
        </Trans>
      ),
      options: [
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.tabs.skincaredetection">
              Skincare Detection
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/skincare-detection',
        },
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skingetresult.title">
              Skin Result Page & Get Skin Result Page
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/skin-result',
        },
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.sharedskinresultpage.title">
              Shared Skin Result Page
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/shared-skin-result-page',
        },
      ],
    },
    {
      show: isSimulation,
      label: (
        <Trans i18nKey="u.s.skincare.aesthetic.simulation">
          Aesthetic Simulation
        </Trans>
      ),
      options: [
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.simulation.page">
              Simulation Page
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/simulation-page',
        },
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.face.assessment.page">
              Face Assessment Page
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/face-assessment',
        },
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.simulationresultpage.getsimulationresult.title">
              Simulation Report Page & Get Simulation Report Page
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/simulation-report',
        },
        {
          label: (
            <Trans i18nKey="p.s.uiconfiguration.sharedsimulationreportpage.title">
              Shared Simulation Report Page
            </Trans>
          ),
          value: '/skincare-pro/ui-configuration/shared-simulation-report-page',
        },
      ],
    },
  ];
};
